<template>
  <v-menu
    v-model="menuState"
    v-bind="resolvedMenuProps"
  >
    <template v-slot:activator="{ on, attrs }">
      <rmr-text-field
        :value="displayValue"
        :label="label"
        :color="color"
        :size="size"
        :hide-details="hideDetails"
        readonly
        :prepend-inner-icon="prependInnerIcon"
        v-bind="buildActivatorAttrs(attrs)"
        v-on="on"
      />
    </template>

    <v-date-picker
      :value="value"
      v-bind="resolvedPickerProps"
      @input="onPickerInput"
      @change="$emit('change', $event)"
    />
  </v-menu>
</template>

<script>
import { RMR_INDIGO } from "@/styles/tokens";
import RmrTextField from "./RmrTextField.vue";

export default {
  name: "RmrDatePickerField",
  components: {
    RmrTextField,
  },
  inheritAttrs: false,
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: [String, Array],
      default: null,
    },
    displayValue: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    menu: {
      type: Boolean,
      default: undefined,
    },
    size: {
      type: String,
      default: "sm",
      validator: (v) => ["sm", "md"].includes(v),
    },
    hideDetails: {
      type: [Boolean, String],
      default: true,
    },
    prependInnerIcon: {
      type: String,
      default: "mdi-calendar",
    },
    closeOnInput: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "date",
    },
    range: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: RMR_INDIGO,
    },
    locale: {
      type: String,
      default: "fr",
    },
    menuProps: {
      type: Object,
      default: () => ({}),
    },
    pickerProps: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      internalMenu: false,
    };
  },
  computed: {
    menuState: {
      get() {
        return this.menu !== undefined ? this.menu : this.internalMenu;
      },
      set(value) {
        if (this.menu !== undefined) {
          this.$emit("update:menu", value);
        } else {
          this.internalMenu = value;
        }

        this.$emit("menu-change", value);
      },
    },
    resolvedMenuProps() {
      return {
        closeOnContentClick: false,
        transition: "scale-transition",
        offsetY: true,
        minWidth: "290px",
        ...this.menuProps,
      };
    },
    resolvedPickerProps() {
      return {
        color: this.color,
        locale: this.locale,
        type: this.type,
        range: this.range,
        ...this.pickerProps,
      };
    },
  },
  methods: {
    buildActivatorAttrs(attrs) {
      return {
        ...this.$attrs,
        ...attrs,
      };
    },
    onPickerInput(value) {
      this.$emit("input", value);

      const selectionIsComplete =
        !this.range || (Array.isArray(value) && value.length === 2);
      if (this.closeOnInput && selectionIsComplete) {
        this.menuState = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .rmr-input .v-input__prepend-inner {
  align-self: center;
  margin-top: 0;
}

::v-deep .rmr-input .v-input__prepend-inner .v-icon {
  color: $rmr-indigo !important;
}
</style>
